export class System {
  systemName: string;
  
  constructor(row: Record<string, string | number | null>) {
    this.systemName = row['systemName'] as string;
  }
}